import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import { Input } from 'reactstrap';
import { notificationValidationStatus, validationProcess, validationProcessFilter } from '../../constants/holcim';
import { getUsers } from "../../store/catalogs/Users/actions";
import { getNotificationManagers, updateNotificationManagerStatus } from "../../store/notifications/managers/actions";
import { AnalysisRequestNewRegisterButton } from './AnalysisRequestNewRegisterButton';
import { AnalysisRequestScheduleReportModal } from './AnalysisRequestScheduleReportModal';
import { Expander } from './Expander';
import Table1 from "./TableContainer";

import { BaseCustomButton, BaseSelectComponent } from '../../shared';

export const NotificationsTab = ({ props, lab}) => {
    
    const [showModal1, setShowModal1] = useState(false); // Para el modal del botón de "atender solicitud"

    const [statusFilter, setStatusFilter] = useState('');
    const [isAttendedFilter, setAttendedFilter] = useState('');
    const [processFilter, setProcessFilter] = useState('');
    const [notifierFilter, setNotifierFilter] = useState('');
    const [endDatedAt, setEndedDatedAt] = useState('');
    const [initialDateAt, setInitialDatedAt] = useState('');

    const [checkBoxArray, setCheckboxArray] = useState([])

    const role = (localStorage.getItem("authUser")) ?  JSON.parse(localStorage.getItem("authUser"))?.role : ''
    const id = (localStorage.getItem("authUser")) ?  JSON.parse(localStorage.getItem("authUser"))?.id : ''

    const onConfirmation = () => {
        

        checkBoxArray.forEach((element, index) => {
            const updValue = {
                recordStatus: true,
                id:element,
            }
            dispatch(updateNotificationManagerStatus(updValue))
        });
    }

    const dispatch = useDispatch();
    
    useEffect(() => {
        // dispatch(getNotificationManagers(`?limit=20&page=0`))
        dispatch(getUsers(`?limit=100&page=0`))
    }, [dispatch])

    useEffect(() => {
        if(role=== 'Laboratorista'){
            dispatch(getNotificationManagers(`?limit=20&page=0&laboratoryType=${lab}&userResponsible=${id}`))
        } else{
            dispatch(getNotificationManagers(`?limit=20&page=0&laboratoryType=${lab}`))
        }
        
        // dispatch(getUsers(`?limit=100&page=0`))
    }, [lab, dispatch, id, role])

    const { notificationManagers, total, currentPage, loading, users  } = useSelector(state => ({
        notificationManagers: state.notificationManagersReducer.notificationManagers,
        loading: state.notificationManagersReducer.loading,
        total: state.notificationManagersReducer.total,
        currentPage: state.notificationManagersReducer.currentPage,
        users: state.usersReducer.users,
    }), shallowEqual);

    const onSetStartDate = (value) => {
        setInitialDatedAt(value.target.value)
    }

    const onSetEndDate = (value) => {
        setEndedDatedAt(value.target.value)
    }

    const getPagination = (params) => {
        if(role=== 'Laboratorista'){
            dispatch(getNotificationManagers(`${params}&laboratoryType=${lab}&userResponsible=${id}`))
        } else{
            dispatch(getNotificationManagers(`${params}&laboratoryType=${lab}`))
        }
        
    }

    const onClickSearch = () => {
        let queryParam = ''
        if (statusFilter && !processFilter && !notifierFilter && !isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}`
        } else if (statusFilter && processFilter && !notifierFilter && !isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}&validateProcess=${processFilter}`
        } else if (statusFilter && processFilter && notifierFilter && !isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}&validateProcess=${processFilter}&userNotifier=${notifierFilter.id}`
        } else if (!statusFilter && processFilter && !notifierFilter && !isAttendedFilter) {
            queryParam = `&validateProcess=${processFilter}`
        } else if (!statusFilter && processFilter && notifierFilter && !isAttendedFilter) {
            queryParam = `&userNotifier=${notifierFilter.id}&validateProcess=${processFilter}`
        } else if (!statusFilter && !processFilter && notifierFilter && !isAttendedFilter) {
            queryParam = `&userNotifier=${notifierFilter.id}`
        } else if (statusFilter && !processFilter && notifierFilter && isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}&userNotifier=${notifierFilter.id}&isAttended=${isAttendedFilter}`
        } else if (statusFilter && processFilter && !notifierFilter && isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}&validateProcess=${processFilter}&isAttended=${isAttendedFilter}`
        } else if (statusFilter && processFilter && notifierFilter && isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}&validateProcess=${processFilter}&userNotifier=${notifierFilter.id}&isAttended=${isAttendedFilter}`
        } else if (!statusFilter && processFilter && !notifierFilter && isAttendedFilter) {
            queryParam = `&validateProcess=${processFilter}&isAttended=${isAttendedFilter}`
        } else if (!statusFilter && processFilter && notifierFilter && isAttendedFilter) {
            queryParam = `&userNotifier=${notifierFilter.id}&validateProcess=${processFilter}&isAttended=${isAttendedFilter}`
        } else if (!statusFilter && !processFilter && notifierFilter && isAttendedFilter) {
            queryParam = `&userNotifier=${notifierFilter.id}isAttended=${isAttendedFilter}`
        } else if (statusFilter && !processFilter && notifierFilter && isAttendedFilter) {
            queryParam = `&validationStatus=${statusFilter}&userNotifier=${notifierFilter.id}&isAttended=${isAttendedFilter}`
        } else if (!statusFilter && !processFilter && !notifierFilter && isAttendedFilter) {
            queryParam = `&isAttended=${isAttendedFilter}`
        } else {
            queryParam = ''
        }
        if (initialDateAt !== '' && endDatedAt !== '') {
            queryParam = `&initialDatedAt=${initialDateAt}&finalDatedAt=${endDatedAt}`
        }
        
        if(role=== 'Laboratorista'){
            dispatch(getNotificationManagers(`?limit=20&page=0&${queryParam}&laboratoryType=${lab}&userResponsible=${id}`))
        } else{
            dispatch(getNotificationManagers(`?limit=20&page=0&${queryParam}&laboratoryType=${lab}`))
        }
    }

    const columns = React.useMemo(
        () => [
            Expander,
            {
                Header: 'Información de la solicitud',
                width: '28%',
                Cell: ({ row }) => (
                    <>
                        <div className='container'>
                            <div className='row py-1'>
                                <div className='text-start col-6'><strong>Folio: </strong>{row.original?.labRequest?.code ?? '-'}</div>
                                <div className='text-start col-6'><strong>Tipo de Laboratorio: </strong>{row.original?.labRequest?.laboratoryArea?.laboratoryType?.name ?? '-'}</div>
                            </div>
                            <div className='row py-1'>
                                <div className='text-start col-6'><strong>Cliente: </strong>{row.original?.labRequest?.customer?.name ?? '-'}</div>
                                <div className='text-start col-6'><strong>Área de Laboratorio: </strong>{row.original?.labRequest?.laboratoryArea?.name ?? '-'}</div>
                            </div>
                            <div className='row py-1'>
                                <div className='text-start col-6'><strong>Asesor técnico: </strong>{row.original?.labRequest?.technicalAdviser?.name ?? '-'}</div>
                                <div className='text-start col-6'><strong>Coordinación: </strong>{row.original?.labRequest?.coordination?.name ?? '-'}</div>
                            </div>
                            <div className='row py-1'>
                                <div className='text-start col-6'><strong>Segmento: </strong>{row.original?.labRequest?.laboratorySegment?.name ?? '-'}</div>
                            </div>
                        </div>
                    </>
                ),
            },
            {
                Header: 'Asunto de la notificación',
                width: '15%',
                Cell: ({ row }) => (
                    <>
                        <div className='text-center'>
                            <strong>{( row.original.validateProcess.includes('/')) ? row.original.validateProcess.split('/')[1]: row.original.validateProcess }</strong>
                        </div>
                    </>
                ),
            },
            {
                Header: 'Detalles',
                width: '20%',
                Cell: ({ row }) => (
                    <>
                        <div className='text-center px-3'><strong> Informador: </strong> </div>
                        <div className='text-center px-3'>{row.original.userNotifier?.name ?? '-'}-{row.original.userNotifier?.surname ?? ''} </div>
                        <hr className='text-success my-2' />
                        <div className='text-center px-3'><strong> Responsable: </strong> </div>
                        {   row.original?.notificationResponsible?.map((dir, index) => {
                            return <div className='text-center'>{dir?.userResponsible?.name ?? '-'}-{dir?.userResponsible?.surname ?? ''} </div>
                        })}
                    </>
                ),
            },
            {
                Header: 'Fecha de asignación',
                // accessor: 'assignmentDate',
                width: '10%',
                Cell: ({ row }) => (
                    <div className='d-flex align-items-end justify-content-center'>
                        <div className='text-center'>{moment(row.original.datedAt).format('YYYY-MM-DD') ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Estatus',
                width: '8%',
                Cell: ({ row }) => (
                    <div>
                        {
                            row.original.validationStatus === 'Proceso de validación' ?
                            <div className='text-warning'>Proceso de validación</div> :
                            row.original.validationStatus === 'Aceptado' ?
                                <div className='text-success'>Aceptado</div> :
                            row.original.validationStatus === 'Rechazado' ?
                                <div className='text-danger'>Rechazado</div> :
                            row.original.validationStatus === 'Autorizado' ?
                                <div className='text-success'>Autorizado</div> :
                            row.original.validationStatus === 'Solicitud de revisión' ?
                                <div className='text-warning'>Solicitud de revisión</div> : ''
                        }
                        <hr className='text-success my-2' />
                        {
                            row.original.recordStatus === false ?
                            <div className='text-warning'>Pendiente</div> :
                                <div className='text-success'>Atendido</div>
                        }
                    </div>
                ),
            },
            {
                width: '8%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div>
                        <div className='d-flex align-items-center justify-content-center mb-1'>
                            <Input className="form-check-input p-3" 
                                disabled={row.original.recordStatus === true} 
                                type="checkbox" id="checkboxNoLabel" 
                                onChange={(value)=>{
                                    if(value.target.checked){
                                        setCheckboxArray(prev => {
                                            if (!prev.includes(row.original.id)) {
                                                return [...prev, row.original.id];
                                            }
                                            return prev;
                                        });
                                    }else{
                                        setCheckboxArray(prev => prev.filter(item => item !== row.original.id));
                                    }
                                  }} 
                                defaultChecked={row.original.recordStatus === true} aria-label="..." />
                        </div>
                        <hr className='text-success my-2' />
                        <Link to={{ pathname: `/labCitec/${row.original.labRequest?.id}` }} className='d-flex align-items-center justify-content-center mb-1'>
                            <BaseCustomButton
                                color="secondary"
                                outline
                                className="d-flex justify-content-center p-1 px-3 py-0 m-0 w-25 text-success"
                                icon="mdi-24px mdi-launch"
                            />
                        </Link>
                    </div>
                ),
            },
        ],
        []
    )

    const renderRowSubComponent = React.useCallback(
        ({ row }) => (
            <div>
                <div className='text-left'>Observaciones: {row.original?.description ?? '-'}</div>
            </div>
        ),
        []
    )

    const statusOptions = notificationValidationStatus.map((dir) => ({
        value: dir.id,
        label: dir.value,
    }));

    const processData = (role === 'Asesor Técnico' ? validationProcessFilter : validationProcess);
    const processOptions = processData.map((dir) => ({
        value: dir.id,
        label: dir.value,
    }));

    const attendedOptions = [
        { value: '', label: 'Seleccionar Estatus' },
        { value: 'yes', label: 'Atendido' },
        { value: 'no', label: 'Pendiente' },
    ];

    const userOptions = users.map((u) => ({
        value: u.id,
        label: `${u.name ?? '-'} ${u.surname ?? ''}`,
    }));

    return (
        <>
          <div className='d-flex justify-content-end px-3 me-3'>
            <AnalysisRequestNewRegisterButton
              showModal={showModal1}
              setShowModal={setShowModal1}
              text='Atender Solicitud'
              icon='attendRequest'
            />
            <AnalysisRequestScheduleReportModal
              props={props}
              showModal={showModal1}
              setShowModal={setShowModal1}
              onScheduleConfirmation={onConfirmation}
              modalHeader='Ésta acción actualizará el estatus de la solicitud'
              modalBodyLabel='¿Desea continuar?'
            />
          </div>
    
          <div className="page-title-box d-flex align-items-end justify-content-between px-3 w-100">
            <div className='w-25 me-3'>
              <label className='text-primary ml-1 rounded-3'>Estatus</label>
              <BaseSelectComponent
                placeholder="Seleccionar Estatus"
                options={statusOptions}
                value={
                  statusFilter
                    ? {
                        value: statusFilter,
                        label: statusOptions.find((el) => el.value === statusFilter)?.label || '',
                      }
                    : null
                }
                onChangeAsObject={true}
                onChange={(selectedOption) => {
                  setStatusFilter(selectedOption?.value || '');
                }}
              />
            </div>
    
            <div className='w-25 me-3'>
              <label className='text-primary ml-1 rounded-3'>Informador</label>
              <BaseSelectComponent
                placeholder="Seleccione Informador..."
                options={userOptions}
                value={
                  notifierFilter
                    ? {
                        value: notifierFilter.id,
                        label: `${notifierFilter.name ?? '-'} ${notifierFilter.surname ?? ''}`,
                      }
                    : null
                }
                onChangeAsObject={true}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    const foundUser = users.find((u) => u.id === selectedOption.value);
                    setNotifierFilter(foundUser || null);
                  } else {
                    setNotifierFilter(null);
                  }
                }}
                allowClear
              />
            </div>
    
            <div className='w-25 me-3'>
              <label className='text-primary ml-1 rounded-3'>Proceso a Validar</label>
              <BaseSelectComponent
                placeholder="Seleccionar Proceso"
                options={processOptions}
                value={
                  processFilter
                    ? {
                        value: processFilter,
                        label: processOptions.find((p) => p.value === processFilter)?.label || '',
                      }
                    : null
                }
                onChangeAsObject={true}
                onChange={(selectedOption) => {
                  setProcessFilter(selectedOption?.value || '');
                }}
              />
            </div>
    
            <div className='w-25 me-3'>
            <BaseCustomButton
                onClick={onClickSearch}
                color="dark"
                className="rounded-3 py-2 w-100"
                icon="mdi-magnify"
                label="Buscar"
            />
            </div>
          </div>
    
          <div className="page-title-box d-flex align-items-end justify-content-between px-3 w-100">
            <div className='w-100 me-2'>
              <label className='text-primary'>Fecha Inicio</label>
              <Input
                name="initialDateAt"
                className="form-control rounded-3 text-primary"
                type='date'
                onChange={onSetStartDate}
              />
            </div>
    

            <div className='w-100 me-2'>
              <label className='text-primary'>Fecha Fin</label>
              <Input
                name="endDatedAt"
                className="form-control rounded-3 text-primary"
                type='date'
                onChange={onSetEndDate}
              />
            </div>
    
            <div className='w-100 me-3'>
              <label className='text-primary ml-1 rounded-3'>Estatus de Atención</label>
              <BaseSelectComponent
                placeholder="Seleccionar Estatus"
                options={attendedOptions}
                value={
                  isAttendedFilter
                    ? {
                        value: isAttendedFilter,
                        label: isAttendedFilter === 'yes' ? 'Atendido' : 'Pendiente',
                      }
                    : null
                }
                onChangeAsObject={true}
                onChange={(selectedOption) => {
                  setAttendedFilter(selectedOption?.value || '');
                }}
              />
            </div>
          </div>
    
          <Table1
            renderRowSubComponent={renderRowSubComponent}
            currentPage={currentPage}
            getPagination={getPagination}
            total={total}
            loading={loading}
            isAddTableBorderStrap
            columns={columns}
            data={notificationManagers}
          />
        </>
    );
};